var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject,on:{"click":function($event){return _vm.toggle()}}},[(_vm.raw)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }